import _ from 'lodash'
import React, { Component, PropTypes } from 'react'

import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import EditableField from 'components/editable-field'
import Loader from 'components/loader'
import MetadataWrapper from 'components/metadata-wrapper'
import PrimaryButton from 'components/primary-button'
import PrimaryButtonResponsive from 'components/primary-button-responsive'
import SecondaryButton from 'components/secondary-button'
import ButtonGroup from 'components/button-group'

import styles from './event-group-details-page.css'


const taglineDescription = `A short pithy description of your event which
will be displayed alongside it when shown on YPlan.`

const eventDescription = `Describe the event to your customers. Provide as much
information as possible, while trying to keep it witty and concise.`

const offerDescription = `A short offer description (maximum 24 characters)
which will appear in the Offer section on the product page.`


export class EventGroupDetailsPage extends Component {
  constructor(props) {
    super(props)
    this.onChangeMode = this.onChangeMode.bind(this)
    this.onSave = this.onSave.bind(this)
    this.onUpdateValue = this.onUpdateValue.bind(this)
    this.getEditableProperty = this.getEditableProperty.bind(this)
  }

  onSave() {
    this.props.draftEventGroupSave()
  }

  onChangeMode() {
    if (this.props.editable) {
      this.props.draftEventGroupCancel()
    } else {
      this.props.draftEventGroupEdit(this.props.eventGroup)
    }
  }

  onUpdateValue(eventGroupId, field, value) {
    this.props.draftEventGroupUpdateField(eventGroupId, { [field]: value })
  }

  getEditableProperty(propertyName) {
    const eventGroup = this.props.eventGroup
    if (!this.props.editable) {
      return eventGroup[propertyName]
    }

    const draftEventGroup = this.props.draftEventGroup
    return draftEventGroup && _.has(draftEventGroup, propertyName)
      ? draftEventGroup[propertyName]
      : eventGroup[propertyName]
  }

  render() {
    const editable = this.props.editable
    const { eventGroup, venue, saving } = this.props


    const imageStyle = {
      backgroundImage: `url('${eventGroup.imageUrl}')`,
    }

    return (
      <div styleName="page">
        <div styleName="image-container">
          <div style={imageStyle} styleName="image" />
        </div>

        <RelayoutWrapper>
          <Relayout align="center">
            <RelayoutItem sm="0" md="12">
              <div styleName="buttons">
                {editable ?
                  <div>
                    <SecondaryButton disabled={saving} label="Cancel" onClick={this.onChangeMode} />
                    <div styleName="save-button">
                      <PrimaryButton disabled={saving} label="Save" onClick={this.onSave} />
                    </div>
                  </div>
                  :
                  <div>
                    {/* We probably will add a history button in this page (discussed with Jo Wilcock) */}
                    {/* <Link styleName="history-button" to={historyLink}> */}
                    {/* <PrimaryButtonResponsive disabled={saving} label="History" /> */}
                    {/* </Link> */}
                    <PrimaryButtonResponsive disabled={false} label="Edit" onClick={this.onChangeMode} />
                  </div>
                }
              </div>
            </RelayoutItem>
            <RelayoutItem sm="12" md="0">

              <div styleName="button-group">
                <ButtonGroup
                  buttons={
                    editable ?
                    [{ text: 'Cancel', onClick: this.onChangeMode },
                      { text: 'Save', onClick: this.onSave, isPrimary: true }]
                    :
                    [{ text: 'Edit', onClick: this.onChangeMode }]
                  }
                  disabled={saving}
                />

              </div>
            </RelayoutItem>
            <RelayoutItem xl="10">
              {saving &&
                <div styleName="overlay">
                  <Loader center />
                </div>
              }
              <MetadataWrapper className="venue" label="Venue">{`${venue.name} (${venue.area})`}</MetadataWrapper>

              <MetadataWrapper className="category" label="Category">{eventGroup.eventType}</MetadataWrapper>

              {eventGroup.tagline &&
                <MetadataWrapper className="tagline" label="Tagline" description={taglineDescription}>
                  {eventGroup.tagline}
                </MetadataWrapper>
              }

              {eventGroup.description &&
                <MetadataWrapper className="description" label="Description" description={eventDescription}>
                  <EditableField
                    value={this.getEditableProperty('rawDescription')}
                    editable={editable}
                    type={"wysiwyg"}
                    onChange={e => this.onUpdateValue(eventGroup.id, 'rawDescription', e.target.value)}
                    primary
                    important
                  />
                </MetadataWrapper>
              }

              {
                <MetadataWrapper className="offer-description" label="Offer Description" description={offerDescription}>
                  <EditableField
                    value={this.getEditableProperty('rawOfferText')}
                    editable={editable}
                    onChange={e => this.onUpdateValue(eventGroup.id, 'rawOfferText', e.target.value)}
                    primary
                    important
                  />
                </MetadataWrapper>
              }

              {eventGroup.youtubeUrl &&
                <MetadataWrapper className="youtube-url" label="Youtube URL">{eventGroup.youtubeUrl}</MetadataWrapper>
              }

              {eventGroup.redeemInstructions &&
                <MetadataWrapper className="redeem-instructions" label="Redeem Instructions">
                  <EditableField
                    value={this.getEditableProperty('rawRedeemInstructions')}
                    editable={editable}
                    type={"textarea"}
                    onChange={e => this.onUpdateValue(eventGroup.id, 'rawRedeemInstructions', e.target.value)}
                    primary
                    important
                  />
                </MetadataWrapper>
              }

              {eventGroup.termsOfEntry &&
                <MetadataWrapper className="terms-entry" label="Terms of Entry">
                  <EditableField
                    value={this.getEditableProperty('rawTermsOfEntry')}
                    editable={editable}
                    type={"wysiwyg"}
                    onChange={e => this.onUpdateValue(eventGroup.id, 'rawTermsOfEntry', e.target.value)}
                    primary
                    important
                  />
                </MetadataWrapper>
              }

              {eventGroup.boxOfficeContact &&
                <MetadataWrapper className="box-office" label="Box office contact">
                  {eventGroup.boxOfficeContact &&
                    <div className="box-office-contact">{eventGroup.boxOfficeContact}</div>
                  }
                  {eventGroup.boxOfficeEmail &&
                    <div className="box-office-email">{eventGroup.boxOfficeEmail}</div>
                  }
                  {eventGroup.boxOfficePhone &&
                    <div className="box-office-phone">{eventGroup.boxOfficePhone}</div>
                  }
                </MetadataWrapper>
              }
            </RelayoutItem>
          </Relayout>
        </RelayoutWrapper>
      </div>
    )
  }
}

EventGroupDetailsPage.propTypes = {
  eventGroup: PropTypes.object,
  venue: PropTypes.object,
  editable: PropTypes.bool,
  saving: PropTypes.bool,
  draftEventGroup: PropTypes.object,
  draftEventGroupCancel: PropTypes.func,
  draftEventGroupEdit: PropTypes.func,
  draftEventGroupSave: PropTypes.func,
  draftEventGroupUpdateField: PropTypes.func,
}

export default CSSModules(EventGroupDetailsPage, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/event-group-details-page/event-group-details-page.js
 **/